export const getRouterPath = ({ route, pathname, search }) => {
  const { path: oldPathname, fullPath } = route

  const oldSearch = fullPath.split('?')[1] || ''

  if (
    pathname !== null &&
    search !== null &&
    (oldPathname !== pathname || `?${oldSearch}` !== search)
  ) {
    return `${pathname}${search || ''}`
  }
}

export const getMfeOnNavigate = (route, router, pathname, search) => {
  const path = getRouterPath({
    route,
    pathname,
    search
  })

  if (path) {
    router.push({ path })
  }
}
